import * as t from './actionTypes';

const initialState= {
    isFetching: false,
    item: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case t.REQUEST_TRANSACTIONS:
            return {
                ...state,
                isFetching: true
            };
        case t.RECEIVE_TRANSACTIONS:
            return {
                ...state,
                isFetching: false,
                item: action.transactions
            };
        case t.LOGOUT:
            return initialState;
        default:
            return state
    }
};